export const EMAIL_REGEX = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/;
export const NO_2_CONSECUTIVE_DOTS_REGEX = /^(?!.*?\.\.).*?$/;